function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F1F2F2",
  d: "M21.245 12.211A7.417 7.417 0 1 1 8.398 4.794a7.417 7.417 0 0 1 12.847 7.417"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#c5c0d6",
  stroke: "#72659F",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.5,
  d: "M21.245 12.211A7.417 7.417 0 1 1 8.398 4.794a7.417 7.417 0 0 1 12.847 7.417z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#c5c0d6",
  stroke: "#72659F",
  strokeWidth: 0.5,
  d: "M20.077 11.537a6.068 6.068 0 1 1-10.51-6.069 6.068 6.068 0 0 1 10.51 6.069M5.132 30.493a1.266 1.266 0 0 1-1.724.462l-2.322-1.34a1.266 1.266 0 0 1-.463-1.726l6.619-11.464a1.266 1.266 0 0 1 1.725-.461l2.322 1.34c.601.347.81 1.123.463 1.725l-6.62 11.464z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F1F2F2",
  d: "M.828 27.534l4.51 2.604"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#72659F",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.521,
  d: "M.828 27.534l4.51 2.604"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#F1F2F2",
  d: "M11.113 14.927l-.985 1.707"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#72659F",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.521,
  d: "M11.113 14.927l-.985 1.707"
})), /*#__PURE__*/React.createElement("text", {
  fill: "#72659F",
  fontFamily: "Nunito-Regular, Nunito",
  fontSize: 12,
  transform: "translate(-5 -2)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 16.14,
  y: 14
}, "+")));

function SvgIconZoom(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 32,
    viewBox: "0 0 23 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconZoom);
export default __webpack_public_path__ + "static/media/iconZoom.f16f33ea.svg";
export { ForwardRef as ReactComponent };